import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { autoinject, inject } from '../Utils/AutoInject';
import { isUserTask, TasksStore } from '../Utils/TasksStore';
import { NotificationToast } from './NotificationToast';
import {toArray} from "../Utils/Array";

@autoinject
@observer
export class NotificationToastList extends React.Component {
    public render() {
        return (
            <div className="toast-list">
                {this.toasts.map(t => (
                    <NotificationToast key={isUserTask(t) ? t.userTaskGuid : t.sessionTaskGuid} task={t} />
                ))}
            </div>
        );
    }
    
    @computed
    private get toasts(){
        const tasks = this.tasksStore.toastTasks;
        let length = tasks.length;
        let start = length > 1 ? length - 1 : 0;

        return tasks.slice(start, length);
    }

    @inject
    private readonly tasksStore!: TasksStore;
}
